import React, { useState } from 'react';
import {
  ScanArea,
  ManualEntry,
  ScannedBanner,
  ProductDetail,
  ActionGrid,
} from './components';
import { ScannedProduct, actionItems } from './scannerTypes';
import { lookupSkuByBarcode } from '../../../services/skusApi';
import styles from './WarehouseScanner.module.css';

const WarehouseScanner: React.FC = () => {
  const [view, setView] = useState<'scan' | 'result'>('scan');
  const [product, setProduct] = useState<ScannedProduct | null>(null);
  const [error, setError] = useState<string | null>(null);

  const lookup = async (code: string) => {
    setError(null);
    if (!code.trim()) return;
    try {
      // Resolve by barcode (falls back to sku_code on the backend).
      const sku = await lookupSkuByBarcode(code.trim());
      setProduct({
        barcode: sku.barcode || sku.sku_code,
        sku: sku.sku_code,
        location: '—',
        availableQty: `${sku.total_stock} units`,
        batch: '—',
        expiry: '—',
      });
      setView('result');
    } catch (err) {
      // Backend returns 404 with a descriptive message when nothing matches.
      setError(err instanceof Error ? err.message : `No product found for "${code}"`);
      setProduct(null);
      setView('result');
    }
  };

  const handleScan = () => {
    setError('Camera scanning is not yet enabled. Use manual entry below.');
    setView('result');
  };

  const handleLookup = (barcode: string) => {
    lookup(barcode);
  };

  const handleRescan = () => {
    setView('scan');
    setProduct(null);
    setError(null);
  };

  const handleAction = (_id: string) => undefined;

  return (
    <div className={styles.container}>
      {view === 'scan' ? (
        <>
          <ScanArea onClick={handleScan} />
          <div className={styles.divider} />
          <ManualEntry onLookup={handleLookup} />
        </>
      ) : (
        <>
          <ScannedBanner barcode={product?.barcode || '—'} onRescan={handleRescan} />
          {error && (
            <div style={{ padding: 12, background: '#FEF2F2', color: '#B91C1C', borderRadius: 6, margin: '12px 0' }}>
              {error}
            </div>
          )}
          {product && <ProductDetail product={product} />}
          {product && <ActionGrid actions={actionItems} onAction={handleAction} />}
        </>
      )}
    </div>
  );
};

export const WarehouseScannerPage: React.FC = () => <WarehouseScanner />;
export default WarehouseScanner;
